const hasAccessToProducts = ({ xtm, xtp, jobs, ebp }) =>
  xtm || xtp || jobs || ebp

export default ({ permissions }) => {
  if (!permissions) {
    return false
  }

  const has360 = !!permissions.products?.["360"]

  return hasAccessToProducts(permissions.products) || has360
}
